<template>
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i :class="icon" />
        </div>
        <div>
          {{heading}}
          <div class="page-title-subheading">{{subheading}}</div>
        </div>
      </div>
      <div class="page-title-actions">
        <div class="row" v-if="extra">
          <div class="col"></div>
          <div class="col-6 text-justify">
            <div class="page-title-subheading">{{extra}}</div>
          </div>
        </div>
        <!-- <button type="button" class="btn-shadow mr-3 btn btn-dark">
          <font-awesome-icon icon="star" />
        </button> -->
        <!-- <button type="button" class="btn-shadow d-inline-flex align-items-center btn btn-success">
          <font-awesome-icon class="mr-2" icon="video" />Video
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import {
  faStar as fasStar,
  faPlus as fasPlus,
  faCog as fasCog,
  faBusinessTime as fasBusinessTime,
  faSearch as fasSearch,
  faHome as fasHome,
  faUser as fasUser,
  faUsers as fasUsers,
  faBuilding as fasBuilding,
  faFileInvoiceDollar as fasFileInvoiceDollar,
  faFileAlt as fasFileAlt,
  faFileDownload as fasFileDownload,
  faBell as fasBell,
  faPowerOff as fasPowerOff,
  faVideo as fasVideo,
  faUserCheck as fasUserCheck,
  faProjectDiagram as fasProjectDiagram,
  faShapes as fasShapes,
  faMoneyCheckAlt as fasMoneyCheckAlt,
  faHistory as fasHistory,
  faTags as fasTags,
  faUserShield as fasUserShield,
  faUserLock as fasUserLock,
  faCloudDownloadAlt as fasCloudDownloadAlt,
  faBook as fasBook,
  faUserFriends as fasUserFriends
} from '@fortawesome/free-solid-svg-icons'
import {
  faFileAlt as farFileAlt,
  faClone as farClone,
  faBuilding as farBuilding,
  faIdCard as farIdCard,
  faAddressCard as farAddressCard,
  faCheckCircle as farCheckCircle,
  faTimesCircle as farTimesCircle,
  faFolderOpen as farFolderOpen,
  faBell as farBell
} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  fasStar,
  fasPlus,
  fasCog,
  fasBusinessTime,
  fasSearch,
  fasHome,
  fasUser,
  fasUsers,
  fasBuilding,
  fasFileInvoiceDollar,
  fasFileAlt,
  fasFileDownload,
  fasBell,
  fasPowerOff,
  fasVideo,
  fasUserCheck,
  fasProjectDiagram,
  fasShapes,
  fasMoneyCheckAlt,
  fasHistory,
  fasTags,
  fasUserShield,
  fasUserLock,
  fasCloudDownloadAlt,
  fasBook,
  fasUserFriends,
  farFileAlt,
  farClone,
  farBuilding,
  farIdCard,
  farAddressCard,
  farCheckCircle,
  farTimesCircle,
  farFolderOpen,
  farBell
)
dom.watch()

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    icon: String,
    heading: String,
    subheading: String,
    extra: String
  }
}
</script>

<style>
.icon-color {
  color: #1e3c72 !important;
}
</style>



// WEBPACK FOOTER //
// src/Layout/Components/PageTitle.vue